import { getJson } from './client';

export type InverterTopology = 'single' | 'master_slave';

export interface TopologyView {
  topology: InverterTopology;
  master_packs: number;
  slave_packs: number;
  total_packs: number;
  display_capacity_kwh: number;
  master_capacity_kwh: number;
}

export interface Installation {
  site_name: string | null;
  grid_connection: string | null;
  grid_max_kw: number | null;
  // Peak-shave drempel (effectief, na site override). Boven dit kW-totaal
  // klampt R5 de export-setpoint terug. v2 TECH-tab toont dit als secundaire
  // referentielijn op de phase-bars (peak_shave_kw / phase_count / 230V → A).
  peak_shave_kw?: number | null;
  // EMS software-ceiling (cycle #13). Verschilt van peak_shave_kw bij sites
  // met ems_margin > 0 (b.v. VJ: peak_shave_kw=44 EPM hardware, ems_max_kw=40
  // software). Dit is de waarde die de EMS daadwerkelijk respecteert tijdens
  // peak-shaving en is daarmee de juiste lijn voor de phase-bars referentie.
  ems_max_kw?: number | null;
  per_phase_amp_budget?: number | null;
  // Fysieke contract-bezekering uit installation.grid_connection ("3x63A").
  // phase_count: 1 of 3. amps_per_phase: 25 / 63 / etc. Beide null als label
  // ontbreekt of onbekend is — frontend toont dan geen contract-marker.
  phase_count?: number | null;
  amps_per_phase?: number | null;
  battery_capacity_kwh: number | null;
  pv_kwp_nominal: number | null;
  saldering_active: boolean | null;
  // Optioneel: backward-compat met oudere Pi's die nog geen topology-block
  // exposeren. Default single bij ontbreken.
  topology?: TopologyView;
}

export function fetchInstallation(): Promise<Installation> {
  return getJson<Installation>('/api/config/installation');
}
